/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {LocaleAdapterInterface} from '@/services/language/types';
import * as moment from 'moment';

/**
 * Moment locale adapter.
 *
 * @implements LocaleAdapterInterface
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export class MomentAdapter implements LocaleAdapterInterface {
    /**
     * Language setter.
     *
     * @param locale
     */
    public setLocale(locale: string): void {
        // configure moment
        moment.locale(locale);
    }
}
